<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M8 2.8a10 10 0 1 1-5.2 13 1 1 0 1 1 1.7-.7 8.1 8.1 0 1 0 .7-7.5h2.1a1 1 0 1 1 0 1.9H2V4.2a1 1 0 0 1 1.9 0v2A10 10 0 0 1 8 2.8"
      clip-rule="evenodd"
    />
    <path
      d="m14.3 10.7-.4.9H8.3l.3-1zm-.8 1.7-.4.9H8.3l.3-.9zm1.8-4-.5 1q-.2 0-.5-.3L13 8.7a2 2 0 0 0-1.2.4q-.6.3-.9 1-.3.9-.3 1.9t.3 1.8.9 1.1 1.2.4l1.3-.4.5-.3.5 1-1 .7a4 4 0 0 1-3.2-.4q-.9-.5-1.3-1.5T9.3 12t.5-2.4q.4-1 1.3-1.6.8-.5 1.9-.5a4 4 0 0 1 2.3.9"
    />
  </svg>
</template>
